import React from 'react';

import {
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  Collapse
} from 'reactstrap';

import {
  NavLink
} from 'react-router-dom';


const MainNav = (props) => (
  <Navbar color="info" light expand="md">
    <NavbarBrand href="/">Michma</NavbarBrand>
    <NavbarToggler onClick={this.toggle} />
    <Collapse isOpen={props.isOpen} navbar>
      <Nav className="ml-auto" navbar>
        <NavItem>
          <NavLink to="/lateFeeCalculator">Late Fee Calculator</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to="/signin">Login</NavLink>
        </NavItem>
      </Nav>
    </Collapse>
  </Navbar>
);

export default MainNav;



// WEBPACK FOOTER //
// ./src/headers/PublicHeader.js